module.exports = __webpack_public_path__ + "img/background.f27f03f7.jpg";